import { render } from "./GatesOverview.vue?vue&type=template&id=794c60e2&scoped=true"
import script from "./GatesOverview.vue?vue&type=script&lang=js"
export * from "./GatesOverview.vue?vue&type=script&lang=js"

import "./GatesOverview.vue?vue&type=style&index=0&id=794c60e2&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-794c60e2"]])

export default __exports__